import React from 'react';
import { TouchableOpacity, View, Text } from 'react-native';
import { styles } from './RadioButton.styles';
import { RadioButtonProps } from './RadioButtonProps';
import { themes } from '../../theme/theme';

const RadioButton: React.FC<RadioButtonProps> = ({
  selected,
  label,
  onPress,
  disabled = false,
  color = themes.light.brand_blue[3],
  testID,
}) => {
  const borderColor = disabled ? themes.light.gray_blue[5] : color;
  const borderWidth = selected ? 7 : 1;
  const marginRight = label ? 8 : 0;

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={styles.container}
      testID={testID}>
      <View
        style={[
          styles.radio,
          {
            borderColor,
            borderWidth,
            marginRight,
          },
        ]}
      />
      {label && (
        <Text style={[styles.label, { color: disabled ? themes.light.gray_blue[5] : color }]}>
          {label}
        </Text>
      )}
    </TouchableOpacity>
  );
};

export default RadioButton;
